import { AuthUser, EntitlementStatus, ProductAccessContext, ProductID, UserRole } from "../models/User";

type RoleSource = {
  role?: UserRole | null;
  access?: Partial<ProductAccessContext> | null;
};

export const CHAT_PRODUCT_ID: ProductID = "VOID_CHAT";

const deniedEntitlementStatuses: ReadonlyArray<EntitlementStatus> = [
  "SUSPENDED",
  "CANCELED",
  "EXPIRED",
  "NOT_CONTRACTED",
];

export const userRoleLabels: Record<UserRole, string> = {
  [ UserRole.ADMIN ]: "Administrador",
  [ UserRole.MANAGER ]: "Gerente",
  [ UserRole.ATTENDANT ]: "Atendente",
};

export const userRoleOptions = [
  UserRole.ATTENDANT,
  UserRole.MANAGER,
  UserRole.ADMIN,
] as const;

export const roleGroups: Record<string, ReadonlyArray<UserRole>> = {
  all: [ UserRole.ADMIN, UserRole.MANAGER, UserRole.ATTENDANT ],
  operational: [ UserRole.ADMIN, UserRole.MANAGER, UserRole.ATTENDANT ],
  dashboard: [ UserRole.ADMIN, UserRole.MANAGER ],
  chat: [ UserRole.ADMIN, UserRole.MANAGER ],
  shipments: [ UserRole.ADMIN, UserRole.MANAGER, UserRole.ATTENDANT ],
  contacts: [ UserRole.ADMIN, UserRole.MANAGER ],
  logs: [ UserRole.ADMIN, UserRole.MANAGER ],
};

export const hasRole = ( role: UserRole | null | undefined, allowedRoles: ReadonlyArray<UserRole> = [] ): boolean => (
  Boolean( role ) && allowedRoles.includes( role as UserRole )
);

export const getAssignedRole = ( user?: RoleSource | null ): UserRole | undefined => (
  user?.access?.assignedRole ?? user?.role ?? undefined
);

export const hasProductAccess = ( user?: AuthUser | null, productId: ProductID = CHAT_PRODUCT_ID ): boolean => {
  if( !user ) return false;
  if( !user.access ) return true;

  if( user.access.productId !== productId ) return false;
  if( user.access.userAccess !== "ALLOWED" ) return false;
  if( deniedEntitlementStatuses.includes( user.access.entitlementStatus )) return false;

  return true;
};
